import axios from "axios";

// Lives on the admin panel (Yii2), not the main Laravel API at VUE_APP_APIURL.
// No Content-Type header here on purpose: this client is GET-only (no request
// body), and omitting it keeps the request a CORS "simple request" so the
// browser skips the OPTIONS preflight - that admin domain doesn't currently
// send CORS headers, so avoiding the preflight is one less thing it needs to
// handle once Access-Control-Allow-Origin is added to the actual GET response.
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_APIURL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
  },
});

export default {
  // GET web/type-carte/price?name=<Classic card|Gold card|Platinum card>
  // Responds with the raw price as a JSON string, e.g. "6000.00".
  getPrice(name) {
    return apiClient.get("web/type-carte/price", { params: { name } });
  },
};
